import { EmojiCategory } from '@/shared/types/emojipicker';
import { IconType } from '@/shared/types/types';
import {
  faClock,
  faFaceSmile,
  faDog,
  faLemon,
  faFutbol,
  faCarSide,
  faLightbulb,
  faHeart,
  faFlag,
} from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'recent',
    name: 'Recientes',
    icon: faClock as IconProp,
    emojis: [],
  },
  {
    id: 'smileys',
    name: 'Sonrisas y personas',
    icon: faFaceSmile as IconProp,
    emojis: [
      '😀',
      '😃',
      '😄',
      '😁',
      '😆',
      '😅',
      '🤣',
      '🙂',
      '🙃',
      '🫠',
      '😉',
      '😊',
      '😇',
      '🥰',
      '😍',
      '🤩',
      '😘',
      '😗',
      '☺️',
      '😚',
      '🥲',
      '😋',
      '😛',
      '😜',
      '🤪',
      '😝',
      '🤑',
      '🤗',
      '🤭',
      '🫣',
      '🤫',
      '🤔',
      '🫡',
      '🤐',
      '🤨',
      '😐',
      '😑',
      '😶',
      '😶‍🌫️',
      '😏',
      '😒',
      '🙄',
      '😬',
      '😮‍💨',
      '🤥',
      '😌',
      '😔',
      '😪',
      '🤤',
      '😴',
      '😷',
      '🤒',
      '🤕',
      '🤢',
      '🤮',
      '🤧',
      '🥵',
      '🥶',
      '🥴',
      '😵',
      '😵‍💫',
      '🤯',
      '🤠',
      '🥳',
      '🥸',
      '😎',
      '🤓',
      '🧐',
      '😕',
      '🫤',
      '😟',
      '🙁',
      '☹️',
      '😮',
      '😯',
      '😲',
      '😳',
      '🥺',
      '🥹',
      '😦',
      '😧',
      '😨',
      '😰',
      '😥',
      '😢',
      '😭',
      '😱',
      '😖',
      '😣',
      '😞',
      '😓',
      '😩',
      '😫',
      '🥱',
    ],
  },
  {
    id: 'animals',
    name: 'Animales',
    icon: faDog as IconProp,
    emojis: [
      '🐕',
      '🐶',
      '🐱',
      '🐈',
      '🐈‍⬛',
      '🦁',
      '🐯',
      '🐅',
      '🐆',
      '🐴',
      '🐎',
      '🦄',
      '🦓',
      '🦌',
      '🦬',
      '🐮',
      '🐂',
      '🐃',
      '🐄',
      '🐷',
      '🐖',
      '🐗',
      '🐽',
      '🐏',
      '🐑',
      '🐐',
      '🐪',
      '🐫',
      '🦙',
      '🦒',
      '🐘',
      '🦣',
      '🦏',
      '🦛',
      '🐭',
      '🐁',
      '🐀',
      '🐹',
      '🐰',
      '🐇',
      '🐿️',
      '🦫',
      '🦔',
      '🦇',
      '🐻',
      '🐻‍❄️',
      '🐨',
      '🐼',
      '🦥',
      '🦦',
      '🦨',
      '🦘',
      '🦡',
      '🐾',
      '🦃',
      '🐔',
      '🐓',
      '🐣',
      '🐤',
      '🐥',
      '🐦',
      '🐧',
      '🕊️',
      '🦅',
      '🦆',
      '🦢',
      '🦉',
      '🦤',
      '🪶',
      '🦩',
      '🦚',
      '🦜',
      '🐸',
      '🐊',
      '🐢',
      '🦎',
      '🐍',
      '🐲',
      '🐉',
      '🦕',
      '🦖',
      '🐳',
      '🐋',
      '🐬',
      '🦭',
      '🐟',
      '🐠',
      '🐡',
      '🦈',
      '🐙',
      '🐚',
      '🦀',
      '🦞',
      '🦐',
      '🦑',
      '🐌',
      '🦋',
      '🐛',
      '🐜',
      '🐝',
      '🪲',
      '🐞',
      '🦗',
      '🪳',
      '🕷️',
      '🕸️',
      '🦂',
      '🦟',
      '🪰',
      '🪱',
      '🦠',
    ],
  },
  {
    id: 'food',
    name: 'Comida',
    icon: faLemon as IconProp,
    emojis: [
      '🍇',
      '🍈',
      '🍉',
      '🍊',
      '🍋',
      '🍌',
      '🍍',
      '🥭',
      '🍎',
      '🍏',
      '🍐',
      '🍑',
      '🍒',
      '🍓',
      '🫐',
      '🥝',
      '🍅',
      '🫒',
      '🥥',
      '🥑',
      '🍆',
      '🥔',
      '🥕',
      '🌽',
      '🌶️',
      '🫑',
      '🥒',
      '🥬',
      '🥦',
      '🧄',
      '🧅',
      '🍄',
      '🥜',
      '🫘',
      '🌰',
      '🍞',
      '🥐',
      '🥖',
      '🫓',
      '🥨',
      '🥯',
      '🥞',
      '🧇',
      '🧀',
      '🍖',
      '🍗',
      '🥩',
      '🥓',
      '🍔',
      '🍟',
      '🍕',
      '🌭',
      '🥪',
      '🌮',
      '🌯',
      '🫔',
      '🥙',
      '🧆',
      '🥚',
      '🍳',
      '🥘',
      '🍲',
      '🫕',
      '🥣',
      '🥗',
      '🍿',
      '🧈',
      '🧂',
      '🥫',
      '🍱',
      '🍘',
      '🍙',
      '🍚',
      '🍛',
      '🍜',
      '🍝',
      '🍠',
      '🍢',
      '🍣',
      '🍤',
      '🍥',
      '🥮',
      '🍡',
      '🥟',
      '🥠',
      '🥡',
      '🦀',
      '🦞',
      '🦐',
      '🦑',
      '🦪',
      '🍦',
      '🍧',
      '🍨',
      '🍩',
      '🍪',
      '🎂',
      '🍰',
      '🧁',
      '🥧',
      '🍫',
      '🍬',
      '🍭',
      '🍮',
      '🍯',
      '🍼',
      '🥛',
      '☕',
      '🫖',
      '🍵',
      '🍶',
      '🍾',
      '🍷',
      '🍸',
      '🍹',
      '🍺',
      '🍻',
      '🥂',
      '🥃',
      '🫗',
      '🥤',
      '🧋',
      '🧃',
      '🧉',
      '🧊',
    ],
  },
  {
    id: 'sports',
    name: 'Deportes',
    icon: faFutbol as IconProp,
    emojis: [
      '⚽',
      '🏀',
      '🏈',
      '⚾',
      '🥎',
      '🎾',
      '🏐',
      '🏉',
      '🥏',
      '🎱',
      '🪀',
      '🏓',
      '🏸',
      '🏒',
      '🏑',
      '🥍',
      '🏏',
      '🪃',
      '🥅',
      '⛳',
      '🪁',
      '🏹',
      '🎣',
      '🤿',
      '🥊',
      '🥋',
      '🎽',
      '🛹',
      '🛼',
      '🛷',
      '⛸️',
      '🥌',
      '🎿',
      '⛷️',
      '🏂',
      '🪂',
      '🏋️',
      '🏋️‍♂️',
      '🏋️‍♀️',
      '🤼',
      '🤼‍♂️',
      '🤼‍♀️',
      '🤸',
      '🤸‍♂️',
      '🤸‍♀️',
      '⛹️',
      '⛹️‍♂️',
      '⛹️‍♀️',
      '🤺',
      '🤾',
      '🤾‍♂️',
      '🤾‍♀️',
      '🏌️',
      '🏌️‍♂️',
      '🏌️‍♀️',
      '🏇',
      '🧘',
      '🧘‍♂️',
      '🧘‍♀️',
      '🏄',
      '🏄‍♂️',
      '🏄‍♀️',
      '🏊',
      '🏊‍♂️',
      '🏊‍♀️',
      '🤽',
      '🤽‍♂️',
      '🤽‍♀️',
      '🚣',
      '🚣‍♂️',
      '🚣‍♀️',
      '🧗',
      '🧗‍♂️',
      '🧗‍♀️',
      '🚵',
      '🚵‍♂️',
      '🚵‍♀️',
      '🚴',
      '🚴‍♂️',
      '🚴‍♀️',
      '🏆',
      '🥇',
      '🥈',
      '🥉',
      '🏅',
      '🎖️',
      '🏵️',
      '🎗️',
    ],
  },
  {
    id: 'travel',
    name: 'Viajes',
    icon: faCarSide as IconProp,
    emojis: [
      '🚗',
      '🚕',
      '🚙',
      '🚌',
      '🚎',
      '🏎️',
      '🚓',
      '🚑',
      '🚒',
      '🚐',
      '🛻',
      '🚚',
      '🚛',
      '🚜',
      '🦯',
      '🦽',
      '🦼',
      '🛴',
      '🚲',
      '🛵',
      '🏍️',
      '🛺',
      '🚨',
      '🚔',
      '🚍',
      '🚘',
      '🚖',
      '🚡',
      '🚠',
      '🚟',
      '🚃',
      '🚋',
      '🚞',
      '🚝',
      '🚄',
      '🚅',
      '🚈',
      '🚂',
      '🚆',
      '🚇',
      '🚊',
      '🚉',
      '✈️',
      '🛫',
      '🛬',
      '🛩️',
      '💺',
      '🛰️',
      '🚀',
      '🛸',
      '🚁',
      '🛶',
      '⛵',
      '🚤',
      '🛥️',
      '🛳️',
      '⛴️',
      '🚢',
      '⚓',
      '🪝',
      '⛽',
      '🚧',
      '🚦',
      '🚥',
      '🚏',
      '🗺️',
      '🗿',
      '🗽',
      '🗼',
      '🏰',
      '🏯',
      '🏟️',
      '🎡',
      '🎢',
      '🎠',
      '⛲',
      '⛱️',
      '🏖️',
      '🏝️',
      '🏜️',
      '🌋',
      '⛰️',
      '🏔️',
      '🗻',
      '🏕️',
      '⛺',
      '🛖',
      '🏠',
      '🏡',
      '🏘️',
      '🏚️',
      '🏗️',
      '🏭',
      '🏢',
      '🏬',
      '🏣',
      '🏤',
      '🏥',
      '🏦',
      '🏨',
      '🏪',
      '🏫',
      '🏩',
      '💒',
      '🏛️',
      '⛪',
      '🕌',
      '🕍',
      '🛕',
      '🕋',
      '⛩️',
      '🛤️',
      '🛣️',
      '🗾',
      '🎑',
      '🏞️',
      '🌅',
      '🌄',
      '🌠',
      '🎇',
      '🎆',
      '🌇',
      '🌆',
      '🏙️',
      '🌃',
      '🌌',
      '🌉',
      '🌁',
    ],
  },
  {
    id: 'objects',
    name: 'Objetos',
    icon: faLightbulb as IconProp,
    emojis: [
      '⌚',
      '📱',
      '📲',
      '💻',
      '⌨️',
      '🖥️',
      '🖨️',
      '🖱️',
      '🖲️',
      '🕹️',
      '🗜️',
      '💽',
      '💾',
      '💿',
      '📀',
      '📼',
      '📷',
      '📸',
      '📹',
      '🎥',
      '📽️',
      '🎞️',
      '📞',
      '☎️',
      '📟',
      '📠',
      '📺',
      '📻',
      '🎙️',
      '🎚️',
      '🎛️',
      '🧭',
      '⏱️',
      '⏲️',
      '⏰',
      '🕰️',
      '⌛',
      '⏳',
      '📡',
      '🔋',
      '🔌',
      '💡',
      '🔦',
      '🕯️',
      '🪔',
      '🧯',
      '🛢️',
      '💸',
      '💵',
      '💴',
      '💶',
      '💷',
      '🪙',
      '💰',
      '💳',
      '🪪',
      '💎',
      '⚖️',
      '🪜',
      '🧰',
      '🪛',
      '🔧',
      '🔨',
      '⚒️',
      '🛠️',
      '⛏️',
      '🪚',
      '🔩',
      '⚙️',
      '🪤',
      '🧱',
      '⛓️',
      '🧲',
      '🔫',
      '💣',
      '🧨',
      '🪓',
      '🔪',
      '🗡️',
      '⚔️',
      '🛡️',
      '🚬',
      '⚰️',
      '🪦',
      '⚱️',
      '🏺',
      '🔮',
      '📿',
      '🧿',
      '💈',
      '⚗️',
      '🔭',
      '🔬',
      '🕳️',
      '🩹',
      '🩺',
      '💊',
      '💉',
      '🩸',
      '🧬',
      '🦠',
      '🧫',
      '🧪',
      '🌡️',
      '🧹',
      '🪠',
      '🧺',
      '🧻',
      '🚽',
      '🚰',
      '🚿',
      '🛁',
      '🛀',
      '🧼',
      '🪥',
      '🪒',
      '🧽',
      '🪣',
      '🧴',
      '🛎️',
      '🔑',
      '🗝️',
      '🚪',
      '🪑',
      '🛋️',
      '🛏️',
      '🛌',
      '🧸',
      '🪆',
      '🖼️',
      '🪞',
      '🪟',
      '🛍️',
      '🛒',
      '🎁',
      '🎈',
      '🎏',
      '🎀',
      '🪄',
      '🪅',
      '🎊',
      '🎉',
      '🎎',
      '🏮',
      '🎐',
      '🧧',
      '✉️',
      '📩',
      '📨',
      '📧',
      '💌',
      '📥',
      '📤',
      '📦',
      '🏷️',
      '🪧',
      '📪',
      '📫',
      '📬',
      '📭',
      '📮',
      '📯',
      '📜',
      '📃',
      '📄',
      '📑',
      '🧾',
      '📊',
      '📈',
      '📉',
      '🗒️',
      '🗓️',
      '📆',
      '📅',
      '🗑️',
      '📇',
      '🗃️',
      '🗳️',
      '🗄️',
      '📋',
      '📁',
      '📂',
      '🗂️',
      '🗞️',
      '📰',
      '📓',
      '📔',
      '📒',
      '📕',
      '📗',
      '📘',
      '📙',
      '📚',
      '📖',
      '🔖',
      '🧷',
      '🔗',
      '📎',
      '🖇️',
      '📐',
      '📏',
      '🧮',
      '📌',
      '📍',
      '✂️',
      '🖊️',
      '🖋️',
      '✒️',
      '🖌️',
      '🖍️',
      '📝',
      '✏️',
      '🔍',
      '🔎',
      '🔏',
      '🔐',
      '🔒',
      '🔓',
    ],
  },
  {
    id: 'symbols',
    name: 'Símbolos',
    icon: faHeart as IconProp,
    emojis: [
      '❤️',
      '🧡',
      '💛',
      '💚',
      '💙',
      '💜',
      '🖤',
      '🤍',
      '🤎',
      '💔',
      '❤️‍🔥',
      '❤️‍🩹',
      '❣️',
      '💕',
      '💞',
      '💓',
      '💗',
      '💖',
      '💘',
      '💝',
      '💟',
      '☮️',
      '✝️',
      '☪️',
      '🕉️',
      '☸️',
      '✡️',
      '🔯',
      '🕎',
      '☯️',
      '☦️',
      '🛐',
      '⛎',
      '♈',
      '♉',
      '♊',
      '♋',
      '♌',
      '♍',
      '♎',
      '♏',
      '♐',
      '♑',
      '♒',
      '♓',
      '🆔',
      '⚛️',
      '🉑',
      '☢️',
      '☣️',
      '📴',
      '📳',
      '🈶',
      '🈚',
      '🈸',
      '🈺',
      '🈷️',
      '✴️',
      '🆚',
      '💮',
      '🉐',
      '㊙️',
      '㊗️',
      '🈴',
      '🈵',
      '🈹',
      '🈲',
      '🅰️',
      '🅱️',
      '🆎',
      '🆑',
      '🅾️',
      '🆘',
      '❌',
      '⭕',
      '🛑',
      '⛔',
      '📛',
      '🚫',
      '💯',
      '💢',
      '♨️',
      '🚷',
      '🚯',
      '🚳',
      '🚱',
      '🔞',
      '📵',
      '🚭',
      '❗',
      '❕',
      '❓',
      '❔',
      '‼️',
      '⁉️',
      '🔅',
      '🔆',
      '〽️',
      '⚠️',
      '🚸',
      '🔱',
      '⚜️',
      '🔰',
      '♻️',
      '✅',
      '🈯',
      '💹',
      '❇️',
      '✳️',
      '❎',
      '🌐',
      '💠',
      'Ⓜ️',
      '🌀',
      '💤',
      '🏧',
      '🚾',
      '♿',
      '🅿️',
      '🛗',
      '🈳',
      '🈂️',
      '🛂',
      '🛃',
      '🛄',
      '🛅',
      '🚹',
      '🚺',
      '🚼',
      '⚧️',
      '🚻',
      '🚮',
      '🎦',
      '📶',
      '🈁',
      '🔣',
      'ℹ️',
      '🔤',
      '🔡',
      '🔠',
      '🆖',
      '🆗',
      '🆙',
      '🆒',
      '🆕',
      '🆓',
      '0️⃣',
      '1️⃣',
      '2️⃣',
      '3️⃣',
      '4️⃣',
      '5️⃣',
      '6️⃣',
      '7️⃣',
      '8️⃣',
      '9️⃣',
      '🔟',
      '🔢',
      '#️⃣',
      '*️⃣',
      '⏏️',
      '▶️',
      '⏸️',
      '⏯️',
      '⏹️',
      '⏺️',
      '⏭️',
      '⏮️',
      '⏩',
      '⏪',
      '⏫',
      '⏬',
      '◀️',
      '🔼',
      '🔽',
      '➡️',
      '⬅️',
      '⬆️',
      '⬇️',
      '↗️',
      '↘️',
      '↙️',
      '↖️',
      '↕️',
      '↔️',
      '↪️',
      '↩️',
      '⤴️',
      '⤵️',
      '🔀',
      '🔁',
      '🔂',
      '🔄',
      '🔃',
      '🎵',
      '🎶',
      '➕',
      '➖',
      '➗',
      '✖️',
      '🟰',
      '♾️',
      '💲',
      '💱',
      '™️',
      '©️',
      '®️',
      '〰️',
      '➰',
      '➿',
      '🔚',
      '🔙',
      '🔛',
      '🔝',
      '🔜',
      '✔️',
      '☑️',
      '🔘',
      '🔴',
      '🟠',
      '🟡',
      '🟢',
      '🔵',
      '🟣',
      '⚫',
      '⚪',
      '🟤',
      '🔺',
      '🔻',
      '🔸',
      '🔹',
      '🔶',
      '🔷',
      '🔳',
      '🔲',
      '▪️',
      '▫️',
      '◾',
      '◽',
      '◼️',
      '◻️',
      '🟥',
      '🟧',
      '🟨',
      '🟩',
      '🟦',
      '🟪',
      '⬛',
      '⬜',
      '🟫',
      '🔈',
      '🔇',
      '🔉',
      '🔊',
      '🔔',
      '🔕',
      '📣',
      '📢',
      '👁️‍🗨️',
      '💬',
      '💭',
      '🗯️',
      '♠️',
      '♣️',
      '♥️',
      '♦️',
      '🃏',
      '🎴',
      '🀄',
      '🕐',
      '🕑',
      '🕒',
      '🕓',
      '🕔',
      '🕕',
      '🕖',
      '🕗',
      '🕘',
      '🕙',
      '🕚',
      '🕛',
      '🕜',
      '🕝',
      '🕞',
      '🕟',
      '🕠',
      '🕡',
      '🕢',
      '🕣',
      '🕤',
      '🕥',
      '🕦',
      '🕧',
    ],
  },
  {
    id: 'flags',
    name: 'Banderas',
    icon: faFlag as IconProp,
    emojis: [
      '🏁',
      '🚩',
      '🎌',
      '🏴',
      '🏳️',
      '🏳️‍🌈',
      '🏳️‍⚧️',
      '🏴‍☠️',
      '🇦🇨',
      '🇦🇩',
      '🇦🇪',
      '🇦🇫',
      '🇦🇬',
      '🇦🇮',
      '🇦🇱',
      '🇦🇲',
      '🇦🇴',
      '🇦🇶',
      '🇦🇷',
      '🇦🇸',
      '🇦🇹',
      '🇦🇺',
      '🇦🇼',
      '🇦🇽',
      '🇦🇿',
      '🇧🇦',
      '🇧🇧',
      '🇧🇩',
      '🇧🇪',
      '🇧🇫',
      '🇧🇬',
      '🇧🇭',
      '🇧🇮',
      '🇧🇯',
      '🇧🇱',
      '🇧🇲',
      '🇧🇳',
      '🇧🇴',
      '🇧🇶',
      '🇧🇷',
      '🇧🇸',
      '🇧🇹',
      '🇧🇻',
      '🇧🇼',
      '🇧🇾',
      '🇧🇿',
      '🇨🇦',
      '🇨🇨',
      '🇨🇩',
      '🇨🇫',
      '🇨🇬',
      '🇨🇭',
      '🇨🇮',
      '🇨🇰',
      '🇨🇱',
      '🇨🇲',
      '🇨🇳',
      '🇨🇴',
      '🇨🇵',
      '🇨🇷',
      '🇨🇺',
      '🇨🇻',
      '🇨🇼',
      '🇨🇽',
      '🇨🇾',
      '🇨🇿',
      '🇩🇪',
      '🇩🇬',
      '🇩🇯',
      '🇩🇰',
      '🇩🇲',
      '🇩🇴',
      '🇩🇿',
      '🇪🇦',
      '🇪🇨',
      '🇪🇪',
      '🇪🇬',
      '🇪🇭',
      '🇪🇷',
      '🇪🇸',
      '🇪🇹',
      '🇪🇺',
      '🇫🇮',
      '🇫🇯',
      '🇫🇰',
      '🇫🇲',
      '🇫🇴',
      '🇫🇷',
      '🇬🇦',
      '🇬🇧',
      '🇬🇩',
      '🇬🇪',
      '🇬🇫',
      '🇬🇬',
      '🇬🇭',
      '🇬🇮',
      '🇬🇱',
      '🇬🇲',
      '🇬🇳',
      '🇬🇵',
      '🇬🇶',
      '🇬🇷',
      '🇬🇸',
      '🇬🇹',
      '🇬🇺',
      '🇬🇼',
      '🇬🇾',
      '🇭🇰',
      '🇭🇲',
      '🇭🇳',
      '🇭🇷',
      '🇭🇹',
      '🇭🇺',
      '🇮🇨',
      '🇮🇩',
      '🇮🇪',
      '🇮🇱',
      '🇮🇲',
      '🇮🇳',
      '🇮🇴',
      '🇮🇶',
      '🇮🇷',
      '🇮🇸',
      '🇮🇹',
      '🇯🇪',
      '🇯🇲',
      '🇯🇴',
      '🇯🇵',
      '🇰🇪',
      '🇰🇬',
      '🇰🇭',
      '🇰🇮',
      '🇰🇲',
      '🇰🇳',
      '🇰🇵',
      '🇰🇷',
      '🇰🇼',
      '🇰🇾',
      '🇰🇿',
      '🇱🇦',
      '🇱🇧',
      '🇱🇨',
      '🇱🇮',
      '🇱🇰',
      '🇱🇷',
      '🇱🇸',
      '🇱🇹',
      '🇱🇺',
      '🇱🇻',
      '🇱🇾',
      '🇲🇦',
      '🇲🇨',
      '🇲🇩',
      '🇲🇪',
      '🇲🇫',
      '🇲🇬',
      '🇲🇭',
      '🇲🇰',
      '🇲🇱',
      '🇲🇲',
      '🇲🇳',
      '🇲🇴',
      '🇲🇵',
      '🇲🇶',
      '🇲🇷',
      '🇲🇸',
      '🇲🇹',
      '🇲🇺',
      '🇲🇻',
      '🇲🇼',
      '🇲🇽',
      '🇲🇾',
      '🇲🇿',
      '🇳🇦',
      '🇳🇨',
      '🇳🇪',
      '🇳🇫',
      '🇳🇬',
      '🇳🇮',
      '🇳🇱',
      '🇳🇴',
      '🇳🇵',
      '🇳🇷',
      '🇳🇺',
      '🇳🇿',
      '🇴🇲',
      '🇵🇦',
      '🇵🇪',
      '🇵🇫',
      '🇵🇬',
      '🇵🇭',
      '🇵🇰',
      '🇵🇱',
      '🇵🇲',
      '🇵🇳',
      '🇵🇷',
      '🇵🇸',
      '🇵🇹',
      '🇵🇼',
      '🇵🇾',
      '🇶🇦',
      '🇷🇪',
      '🇷🇴',
      '🇷🇸',
      '🇷🇺',
      '🇷🇼',
      '🇸🇦',
      '🇸🇧',
      '🇸🇨',
      '🇸🇩',
      '🇸🇪',
      '🇸🇬',
      '🇸🇭',
      '🇸🇮',
      '🇸🇯',
      '🇸🇰',
      '🇸🇱',
      '🇸🇲',
      '🇸🇳',
      '🇸🇴',
      '🇸🇷',
      '🇸🇸',
      '🇸🇹',
      '🇸🇻',
      '🇸🇽',
      '🇸🇾',
      '🇸🇿',
      '🇹🇦',
      '🇹🇨',
      '🇹🇩',
      '🇹🇫',
      '🇹🇬',
      '🇹🇭',
      '🇹🇯',
      '🇹🇰',
      '🇹🇱',
      '🇹🇲',
      '🇹🇳',
      '🇹🇴',
      '🇹🇷',
      '🇹🇹',
      '🇹🇻',
      '🇹🇼',
      '🇹🇿',
      '🇺🇦',
      '🇺🇬',
      '🇺🇲',
      '🇺🇳',
      '🇺🇸',
      '🇺🇾',
      '🇺🇿',
      '🇻🇦',
      '🇻🇨',
      '🇻🇪',
      '🇻🇬',
      '🇻🇮',
      '🇻🇳',
      '🇻🇺',
      '🇼🇫',
      '🇼🇸',
      '🇽🇰',
      '🇾🇪',
      '🇾🇹',
      '🇿🇦',
      '🇿🇲',
      '🇿🇼',
      '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
      '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
      '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
    ],
  },
];
